/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IUserState {
  profile: any;
  refetchGetUser: boolean;
  isRejectedDocument: boolean;
}

const initialState: IUserState = {
  profile: null,
  refetchGetUser: false,
  isRejectedDocument: false
};

export const profileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setProfile: (state: IUserState, action: PayloadAction<{}>) => {
      const { payload } = action;
      state.profile = payload;
    },
    setRefetchGetUser: (state: IUserState, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.refetchGetUser = payload;
    },
    setIsRejectedDocument: (state: IUserState, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isRejectedDocument = payload;
    }
  }
});

const { actions, reducer } = profileSlice;
export const { setProfile, setRefetchGetUser, setIsRejectedDocument } = actions;
export default reducer;
